// extracted by mini-css-extract-plugin
module.exports = {"centerLayout":"CenterLayout_centerLayout__3ELlP"};